'use client'

import Pusher from 'pusher-js'
import { createContext, ReactNode, useContext } from 'react'
import { z } from 'zod'

export type ContextPusher = Context

type Context = {
  pusher: Pusher
}

export const PusherContext = createContext<Context>({} as Context)

export const AUTH_ENDPOINT = `${process.env.NEXT_PUBLIC_BACKEND_URL}/broadcasting/auth`
export const PUSHER_APP_KEY = process.env.NEXT_PUBLIC_PUSHER_APP_KEY!
export const PUSHER_WS_HOST = process.env.NEXT_PUBLIC_PUSHER_WS_HOST
export const PUSHER_WS_PORT = process.env.NEXT_PUBLIC_PUSHER_WS_PORT
export const PUSHER_CLUSTER = process.env.NEXT_PUBLIC_PUSHER_CLUSTER!

export const PusherProvider = ({
  accessToken,
  children,
}: {
  accessToken?: null | string
  children: ReactNode
}) => {
  const pusher = new Pusher(PUSHER_APP_KEY, {
    auth: {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
    authEndpoint: AUTH_ENDPOINT,
    cluster: PUSHER_CLUSTER,
    disableStats: false,
    enabledTransports: ['ws'],
    forceTLS: false,
    wsHost: PUSHER_WS_HOST,
    wsPort: PUSHER_WS_PORT ? z.coerce.number().optional().parse(PUSHER_WS_PORT) : undefined,
  })

  return <PusherContext.Provider value={{ pusher }}>{children}</PusherContext.Provider>
}

export const usePusher = () => {
  const context = useContext(PusherContext)
  if (!context) {
    throw new Error('usePusher must be used within a PusherProvider')
  }
  return context
}
